import './TemplateCard.scss';

export interface TemplateCardProps {
	imageUrl: string;
	title?: string;
	subtitle?: string;
}

const TemplateCard: React.FC<TemplateCardProps> = props => {
	return (
		<div className='template-card'>
			<div className='content'>
				<div>
					<img src={props.imageUrl} alt='woman'></img>
				</div>
				{props.title ? (
					<h3 className='template-title'>{props.title}</h3>
				) : (
					''
				)}
				{props.subtitle ? (
					<span className='template-subtitle'>{props.subtitle}</span>
				) : (
					''
				)}
			</div>
		</div>
	);
};

export default TemplateCard;
